<template>
  <!-- 头部 -->
  <div class="header-outer">
    <img src="@/header.png" alt="" />
    <div class="icon" v-show="route != '/home'" @click="goHome">
      <img src="@/header_icon.png" alt="" />
      <div>首页</div>
    </div>
    <div class="header-text" style="font-weight:bold">巩固脱贫攻坚成果 全面推进乡村振兴</div>
    <!-- 日期 -->
    <div id="nowTime">{{ dateYear }} {{ dateDay }} {{ dateWeek }}</div>
  </div>
</template>

<script>
import { formatTime } from '_u/index.js'
export default {
  data() {
    return {
      dateDay: '',
      dateYear: '',
      dateWeek: '',
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      route: '',
    }
  },
  methods: {
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
    goHome() {
      this.$router.push('/')
    },
  },
  mounted() {
    this.timeFn()
    this.route = this.$route.path
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
}
</script>

<style lang="scss">
.header-outer {
  .icon {
    position: absolute;
    top: 20px;
    left: 60px;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 24px;
    color: #ffffff;
    text-shadow: 0 0 10px #04f6f5;
    cursor: pointer;
    user-select: none;
  }
  .header-text {
    font-size: 36px;
    color: #ffffff;
    line-height: 45px;
    font-weight: bold;
    letter-spacing: -1px;
    text-align: center;
    margin-top: -81px;
  }
  #nowTime {
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    width: 280px;
    height: 45px;
    background: #070a3c;
    border-radius: 20px;
    border: 2px solid #128ee8;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #66ffff;
  }
}
</style>
